import React, { Component } from 'react'
import { uid } from 'react-uid'
import './css/scss/footer.scss'
import '../../common/scss/bootstrap.scss'
import apple from './img/Apple Logo_32px.png'
import playStore from './img/Google Play_32px.png'
import login from './img/Contacts_32px.png'
import facebook from './img/icons8_Facebook_32px.png'
import instagram from './img/icons8_Instagram_32px_2.png'
import twitter from './img/icons8_Twitter_32px_1.png'
import tiktok from './img/tiktok_ico.png';
import appGallery from './img/AppGallery_32px.png'
import {getLanguageFromUrl, getSectionFromUrl} from '../../helpers/util'
import FooterColumn from './FooterColumn'
import connect from 'react-redux/es/connect/connect'

class Footer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      section: getSectionFromUrl(),
      content: []
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.pageShell.data !== this.props.pageShell.data) {
      if (nextProps.pageShell.data.footer !== 'undefined') {
        let content = nextProps.pageShell.data.footer[this.state.section].content

        for (let i = 0; i < content.length; i++) {
          if (!content[i].uid) {
            content[i].uid = uid(i)
          }
        }

        this.setState({
          content: content
        })
      }
    }
  }

  render () {
    const language = getLanguageFromUrl();
    const labels = require(`../../trans/${language}`)
    return (
      this.props.pageShell.isFetching ? null :
        <footer>
          <div className="container-fluid footer-container">
            <div className="row">
              <div className="col col-12 col-xl-3 float-md-left logo-column">
                <a href="/" className="footer-logo yettel-bold-font">
                  <span>Yettel.</span>
                </a>
              </div>
              <div className="col col-12 col-xl-9 float-md-left content-column">
                <div className="row">
                  <div className="col col-12 col-xl-3">
                    <div className="footer-head">{labels.callUs}</div>
                    <div className="footer-call-us"><a href="tel:0639000">063 9000</a></div>
                    <div className="footer-moj-telenor">Yettel app</div>
                    <div className="footer-actions">
                      <a href="https://itunes.apple.com/us/app/moj-telenor/id1004559997?mt=8">
                        <img alt={'apple'} className="footer-icon" src={apple}/>
                        <span className="footer-icon-text yettel-light-font">App Store</span>
                      </a>
                    </div>
                    <div className="footer-actions">
                      <a href="https://play.google.com/store/apps/details?id=rs.telenor.mymenu">
                        <img alt={'playStore'} className="footer-icon" src={playStore}/>
                        <span className="footer-icon-text yettel-light-font">Play Store</span>
                      </a>
                    </div>
                    <div className="footer-actions">
                      <a href="https://appgallery.huawei.com/#/app/C101431453?channelId=EURSMKT20200525PI&detailType=0">
                        <img alt={'appGallery'} className="footer-icon" src={appGallery}/>
                        <span className="footer-icon-text yettel-light-font">App Gallery</span>
                      </a>
                    </div>
                    {
                      this.state.section === 'consumer' &&
                      <div className="footer-actions">
                        <a href="https://www.yettel.rs/nalog/">
                          <img alt={'login'} className="footer-icon" src={login}/>
                          <span className="footer-icon-text yettel-light-font">{labels.account}</span>
                        </a>
                      </div>
                    }
                  </div>
                  {
                    this.renderColumns(this.state.content)
                  }
                </div>
              </div>
            </div>
            <div className="row">
              <div className={' col col-12'}>
                <div className="footer-bottom">
                  <div className="d-inline-block float-right footer-social-container">
                    <a href="https://www.tiktok.com/@yettel.srbija">
                      <img width={22} alt={'tiktok'} className="footer-img" src={tiktok}/>
                    </a>
                    <a href="https://twitter.com/YettelSrbija_tw">
                      <img alt={'twitter'} className="footer-img" src={twitter}/>
                    </a>
                    <a href="https://www.facebook.com/YettelSrbija/">
                      <img alt={'facebook'} className="footer-img" src={facebook}/>
                    </a>
                    <a href="https://www.instagram.com/yettelsrbija/">
                      <img alt={'instagram'} className="footer-img" src={instagram}/>
                    </a>
                  </div>
                  <div className="clearfix"></div>
                </div>
              </div>

              <div className="col footer-copy">
                <span>&copy; {new Date().getFullYear()} Yettel Srbija</span>
                <span className="float-right">
                <a
                  href="https://www.yettel.rs/sr/o-yettelu/obavestenje-o-privatnosti/obavestenje-o-kolacicima/"
                  className="text-decoration-none text-white"
                >
                  {labels.privacyPolicy}
                </a>
              </span>
              </div>
            </div>
          </div>
        </footer>
    )
  }

  /**
   *
   * @param columns
   * @returns {*}
   */
  renderColumns (columns) {
    return columns.map((column, index) => {
      return <FooterColumn key={index} expandClickHandler={this.expandClickHandler.bind(this)} column={column}/>
    })
  }

  /**
   *
   * @param uid
   */
  expandClickHandler (uid) {
    let content = this.props.pageShell.data.footer[this.state.section].content

    for (let i = 0; i < content.length; i++) {
      if (content[i].uid === uid) {
        content[i].rows.isHidden = !content[i].rows.isHidden
      } else {
        content[i].rows.isHidden = true
      }
    }

    this.setState({
      content: content
    })
  }
}

const mapStateToProps = state => {
  return {
    pageShell: state.pageShell,
  }
}
export default connect(
  mapStateToProps
)(Footer)
